<template>
  <div class="check-out-page">
    <!-- Camera Section -->
    <div class="camera-container">
      <!-- QR Code Scanner -->
      <QrcodeStream
        v-if="!processing"
        :constraints="{ facingMode: 'user' }"
        class="qr-scanner"
        @detect="onDetect"
        @camera-on="onCameraReady"
        @error="onCameraError"
      >
        <!-- Scanning Overlay -->
        <div class="scanning-overlay">
          <div class="scan-frame">
            <div class="corner corner-tl" />
            <div class="corner corner-tr" />
            <div class="corner corner-bl" />
            <div class="corner corner-br" />

            <div class="scan-line" />
          </div>
        </div>

        <div
          class="mx-4 my-4 px-4 py-4 rounded d-flex gap-4"
          style="background: rgba(0, 0, 0, 60%);"
        >
          <VChip
            color="primary"
            prepend-icon="tabler-arrow-left"
            size="large"
            @click="onClickBack"
          >
            Back
          </VChip>
          <VChip
            color="primary"
            prepend-icon="tabler-door-exit"
            size="large"
          >
            Visitor Check-Out
          </VChip>

          <VSpacer />

          <VChip
            color="success"
            prepend-icon="tabler-scan"
            size="large"
            class="mr-2"
          >
            Scanning Active
          </VChip>
          <VChip
            :color="isDeviceOnline ? 'success' : 'error'"
            :prepend-icon="isDeviceOnline ? 'tabler-wifi' : 'tabler-exclamation-circle'"
            size="large"
          >
            Device {{ isDeviceOnline ? 'Online' : 'Offline' }}
          </VChip>
        </div>

        <!-- Left Side Badges -->
        <!--
          <div class="badges-left">
          <VChip
          color="primary"
          prepend-icon="tabler-arrow-left"
          size="large"
          >
          Back
          </VChip>
          <VChip
          color="primary"
          prepend-icon="tabler-logout"
          size="large"
          >
          Visitor Check-Out
          </VChip>
          </div> 
        -->

        <!-- Right Side Badges -->
        <!--
          <div class="badges-right">
          <VChip
          color="success"
          prepend-icon="tabler-scan"
          size="large"
          >
          Scanning Active
          </VChip>
          <VChip
          color="success"
          prepend-icon="tabler-wifi"
          size="large"
          >
          Device Online
          </VChip>
          </div> 
        -->
      </QrcodeStream>

      <!-- Processing State -->
      <div
        v-else
        class="camera-placeholder"
      >
        <VProgressCircular
          indeterminate
          size="64"
          color="warning"
          class="mb-4"
        />
        <h3 class="text-h6 mb-2">
          Processing Check-Out...
        </h3>
        <p class="text-body-2 text-medium-emphasis">
          Please wait while we verify your QR code
        </p>
      </div>
    </div>

    <!-- Processing Dialog -->
    <VDialog
      v-model="processing"
      width="400"
      persistent
    >
      <VCard>
        <VCardText class="text-center pa-8">
          <VProgressCircular
            indeterminate
            size="64"
            color="warning"
            class="mb-4"
          />
          <h3 class="text-h6 mb-2">
            Processing Check-Out...
          </h3>
          <p class="text-body-2 text-medium-emphasis mb-0">
            Please wait while we verify your QR code
          </p>
        </VCardText>
      </VCard>
    </VDialog>

    <!-- Feedback Dialog -->
    <VDialog
      v-model="showFeedbackDialog"
      width="600"
      persistent
      :close-on-back="false"
    >
      <VCard>
        <VCardItem class="bg-primary pb-4">
          <VCardTitle class="d-flex align-center text-white">
            <VIcon
              icon="tabler-message-star"
              class="me-2"
            />
            How was your visit?
          </VCardTitle>
        </VCardItem>
        <VCardText class="pa-6">
          <VForm
            ref="feedbackForm"
            v-model="feedbackValid"
          >
            <!-- Visitor Info -->
            <!--
              <VAlert
              v-if="checkOutData"
              type="info"
              variant="tonal"
              class="mb-6"
              >
              <div class="d-flex align-center">
              <VAvatar
              color="info"
              size="48"
              class="me-4"
              >
              <VIcon icon="tabler-user" />
              </VAvatar>
              <div>
              <p class="text-subtitle-1 font-weight-bold mb-1">
              {{ checkOutData.visitor_name }}
              </p>
              <p class="text-caption mb-0">
              Check-out Time: {{ checkOutData.check_out_time }}
              </p>
              </div>
              </div>
              </VAlert> 
            -->

            <!-- Star Rating -->
            <div class="mb-6">
              <label class="d-flex align-center gap-2 text-subtitle-1 font-weight-bold d-block mb-3">
                <VIcon
                  icon="tabler-star"
                  size="20"
                />
                Rate Your Experience
              </label>
              <!--
                <div class="d-flex justify-center gap-2 mb-2">
                <VBtn
                v-for="star in 5"
                :key="star"
                :color="feedback.rating >= star ? 'warning' : 'grey-lighten-2'"
                :variant="feedback.rating >= star ? 'flat' : 'outlined'"
                icon
                size="x-large"
                @click="feedback.rating = star"
                >
                <VIcon
                :icon="feedback.rating >= star ? 'tabler-star-filled' : 'tabler-star'"
                size="32"
                />
                </VBtn>
                </div> 
              -->
              <VRating
                v-model="feedback.rating"
                :length="5"
                class="custom-rating"
                color="warning"
                size="60"
                hover
              />
              
              <!--
                <div class="text-center">
                <VChip
                v-if="feedback.rating"
                :color="getRatingColor(feedback.rating)"
                size="small"
                >
                {{ getRatingText(feedback.rating) }}
                </VChip>
                </div> 
              -->
            </div>

            <!-- <VDivider class="my-4" /> -->

            <!-- Feedback Comment -->
            <!-- class="mb-4" -->
            <div>
              <label class="d-flex align-center gap-2 text-subtitle-1 font-weight-bold d-block mb-3">
                <VIcon
                  icon="tabler-message"
                  size="20"
                />
                Additional Comments (Optional)
              </label>
              <VTextarea
                v-model="feedback.comment"
                placeholder="Share your experience with us..."
                variant="outlined"
                rows="4"
                counter
                maxlength="500"
                :rules="[rules.maxLength]"
              />
            </div>

            <!-- Quick Feedback Options -->
            <!--
              <div class="mb-4">
              <label class="text-subtitle-1 font-weight-bold d-block mb-3">
              Quick Feedback Tags
              </label>
              <div class="d-flex flex-wrap gap-2">
              <VChip
              v-for="tag in feedbackTags"
              :key="tag"
              :color="feedback.tags.includes(tag) ? 'primary' : 'default'"
              :variant="feedback.tags.includes(tag) ? 'flat' : 'outlined'"
              filter
              :model-value="feedback.tags.includes(tag)"
              @click="toggleTag(tag)"
              >
              {{ tag }}
              </VChip>
              </div>
              </div> 
            -->
          </VForm>
        </VCardText>

        <VDivider />
        
        <VCardActions class="pa-6">
          <VBtn
            variant="outlined"
            color="grey"
            @click="skipFeedback"
          >
            Skip (Auto Skip in {{ feedbackDialogAutoSkipCountdown }} seconds)
          </VBtn>
          <VSpacer />
          <VBtn
            class="px-4"
            variant="flat"
            prepend-icon="tabler-send"
            :loading="submittingFeedback"
            :disabled="!feedback.rating || submittingFeedback"
            @click="submitFeedback"
          >
            Submit Feedback
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>

    <!-- Success Dialog -->
    <VDialog
      v-model="showSuccessDialog"
      width="500"
      persistent
    >
      <VCard>
        <VCardText class="text-center">
          <VIcon
            icon="tabler-circle-check"
            size="60"
            color="success"
            class="mb-2"
          />
          <!-- mb-2 -->
          <h2 class="text-h4 font-weight-bold text-success">
            Check-Out Successful!
          </h2>
          <!--
            <div class="text-h6">
            Thank you for your visit!
            </div> 
          -->
        </VCardText>

        <VDivider />

        <VCardText>
          <div class="d-flex flex-column gap-2">
            <div class="text-body-1">
              <strong>Visitor:</strong> {{ successData?.session?.visitor?.name || 'N/A' }}
            </div>
            <div class="text-body-1">
              <strong>Check-Out Time:</strong> {{ successData?.session?.checked_out_at ? moment(successData.session.checked_out_at).format('h:mm A') : 'N/A' }}
            </div>
            <div class="text-body-1">
              <strong>Duration:</strong> {{ successData?.session?.visit_duration_formatted || 'N/A' }}
            </div>
          </div>
        </VCardText>

        <VDivider />

        <VCardText>
          <div class="d-flex flex-column align-center gap-2">
            <div class="text-high-emphasis font-weight-semibold text-h5">
              Rate Your Experience
            </div>
            <VRating
              v-model="feedback.rating"
              :length="5"
              class="custom-rating"
              color="warning"
              size="50"
              hover
            />
            <VTextarea
              v-model="feedback.comment"
              class="w-100 my-1"
              label="Give a short note about your experience"
              variant="outlined"
              rows="3"
              counter
              maxlength="500"
              :rules="[rules.maxLength]"
            />
          </div>

          <VBtn
            color="success"
            block
            prepend-icon="tabler-send"
            :loading="submittingFeedback"
            :disabled="!feedback.rating || submittingFeedback"
            @click="submitFeedback"
          >
            Submit Review
          </VBtn>
        </VCardText>

        <VDivider />

        <VCardText class="text-center">
          <div class="text-body-2 text-medium-emphasis">
            This dialog will close automatically in {{ successCountdown }} seconds
          </div>
        </VCardText>

        <!--
          <VCardText class="text-center pa-8">
          <VIcon
          icon="tabler-circle-check"
          size="80"
          color="success"
          class="mb-4"
          />
          <h2 class="text-h4 font-weight-bold mb-2 text-success">
          Check-Out Successful!
          </h2>
          <p class="text-h6 mb-4">
          Thank you for your visit!
          </p>
          <VDivider class="my-4" />
          <div class="text-start">
          <p class="text-body-1 mb-2">
          <strong>Visitor:</strong> {{ successData?.visitor_name || 'N/A' }}
          </p>
          <p class="text-body-1 mb-2">
          <strong>Check-Out Time:</strong> {{ successData?.check_out_time || 'N/A' }}
          </p>
          <p class="text-body-1 mb-2">
          <strong>Duration:</strong> {{ successData?.visit_duration || 'N/A' }}
          </p>
          </div>
          <p class="text-body-2 text-medium-emphasis mt-4">
          This dialog will close automatically in {{ successCountdown }} seconds
          </p>
          </VCardText> 
        -->
      </VCard>
    </VDialog>

    <!-- Error Dialog -->
    <VDialog
      v-model="showErrorDialog"
      width="500"
      persistent
    >
      <VCard>
        <VCardTitle class="bg-error d-flex align-center">
          <VIcon
            icon="tabler-alert-circle"
            class="me-2"
          />
          Check-Out Failed
        </VCardTitle>
        <VCardText class="pa-6">
          <VAlert
            type="error"
            variant="tonal"
            class="mb-4"
          >
            {{ errorMessage }}
          </VAlert>
          <p class="text-body-2 text-medium-emphasis">
            Please try scanning again or contact the reception desk for assistance.
          </p>
        </VCardText>
        <VCardActions class="d-flex flex-column">
          <!-- <VSpacer /> -->
          <VBtn
            color="error"
            variant="flat"
            block
            @click="closeErrorDialog"
          >
            Try Again
          </VBtn>
          <div class="text-body-2 text-medium-emphasis mt-1">
            This dialog will close automatically in {{ errorCountdown }} seconds
          </div>
        </VCardActions>
      </VCard>
    </VDialog>

    <!-- Sound effects (hidden) -->
    <audio
      ref="successSound"
      src="/sounds/kiosk/success.mp3"
      preload="auto"
    />
    <audio
      ref="errorSound"
      src="/sounds/kiosk/error.mp3"
      preload="auto"
    />
  </div>
</template>

<script setup>
import { kioskAuthState } from '@/@core/auth/kioskAuthState'
import { useToast } from '@/composables/useToast'
import moment from 'moment'
import { watch } from 'vue'
import { QrcodeStream } from 'vue-qrcode-reader'
import { useRouter } from 'vue-router'

// Composables
const router = useRouter()
const toast = useToast()

// Define page metadata
definePage({
  meta: {
    layout: 'blank',
    public: true,
    unauthenticatedOnly: true,
    title: 'Visitor Check-Out',
  },
})

const auth = kioskAuthState()

// Page Accessability Checking
if (!auth.token) {
  router.push({
    name: 'care-visit-kiosk-registration',
  })
}

// Refs
const feedbackForm = ref(null)
const successSound = ref(null)
const errorSound = ref(null)

// State
const processing = ref(false)
const showFeedbackDialog = ref(false)
const feedbackDialogAutoSkipCountdown = ref(5)
const showSuccessDialog = ref(false)
const showErrorDialog = ref(false)
const errorMessage = ref('')
const errorCountdown = ref(3)
const successData = ref(null)
const checkOutData = ref(null)
const successCountdown = ref(5)
const feedbackValid = ref(false)
const submittingFeedback = ref(false)
const isDeviceOnline = ref(true)

// Feedback data
const feedback = ref({
  rating: 0,
  comment: '',
  tags: [],
})

const feedbackTags = [
  'Friendly Staff',
  'Clean Facility',
  'Easy Process',
  'Quick Service',
  'Professional',
  'Comfortable',
  'Well Organized',
  'Helpful',
]

// Cooldown management
let lastScannedCode = null
let lastScanTime = 0
let countdownInterval = null
const SCAN_COOLDOWN = 3000 // 3 seconds cooldown between scans

// Validation rules
const rules = {
  maxLength: value => {
    if (!value) return true
    
    return value.length <= 500 || 'Maximum 500 characters allowed'
  },
}

// Methods
// const getRatingColor = rating => {
//   if (rating >= 4) return 'success'
//   if (rating >= 3) return 'warning'
  
//   return 'error'
// }

// const getRatingText = rating => {
//   const texts = {
//     1: 'Poor',
//     2: 'Fair',
//     3: 'Good',
//     4: 'Very Good',
//     5: 'Excellent',
//   }

  
//   return texts[rating] || ''
// }

// const toggleTag = tag => {
//   const index = feedback.value.tags.indexOf(tag)
//   if (index > -1) {
//     feedback.value.tags.splice(index, 1)
//   } else {
//     feedback.value.tags.push(tag)
//   }
// }

const onCameraReady = () => {
  // console.log('Camera is ready')
  // toast.success('Camera initialized successfully')
}

const onCameraError = error => {
  console.error('Camera error:', error)

  let errorMsg = 'Failed to access camera.'

  if (error.name === 'NotAllowedError') {
    errorMsg = 'Camera access denied. Please allow camera permissions.'
  } else if (error.name === 'NotFoundError') {
    errorMsg = 'No camera found on this device.'
  } else if (error.name === 'NotReadableError') {
    errorMsg = 'Camera is already in use by another application.'
  } else if (error.name === 'OverconstrainedError') {
    errorMsg = 'Camera constraints not supported.'
  }

  toast.error(errorMsg)
}

const onDetect = async detectedCodes => {
  console.log('🔍 Detect event fired!', detectedCodes)

  if (processing.value) {
    console.log('⏸️ Already processing, skipping...')
    
    return
  }

  if (!detectedCodes || detectedCodes.length === 0) {
    console.log('❌ No codes detected')
    
    return
  }

  // Get the first detected QR code
  const firstCode = detectedCodes[0]
  const qrData = firstCode.rawValue

  console.log('✅ QR Code detected:', qrData)

  // Check cooldown to prevent duplicate scans
  const now = Date.now()
  if (lastScannedCode === qrData && (now - lastScanTime) < SCAN_COOLDOWN) {
    console.log('⏰ Cooldown active, skipping duplicate scan')
    
    return
  }

  lastScannedCode = qrData
  lastScanTime = now

  console.log('🚀 Processing check-out...')
  processing.value = true

  // * Check Out API Call
  await $api('/care-visit/kiosk/check-out/qr', {
    method: 'POST',
    body: JSON.stringify({
      qr_token: qrData,
    }),
  }).then(({ success, message, data }) => {
    console.log('✅ API Response:', success, message, data)

    // Simulated response (replace with actual API response)
    // const response = {
    //   data: {
    //     success: true,
    //     visitor_name: 'John Doe',
    //     visitor_id: '12345',
    //     check_out_time: new Date().toLocaleTimeString(),
    //     visit_duration: '2 hours 30 minutes',
    //     qr_code: qrData,
    //   },
    // }

    processing.value = false

    if (success) {
      successData.value = data

      checkOutData.value = {
        session_id: data?.session?.id,
      }

      // Show feedback dialog
      // showFeedbackDialog.value = true
      showSuccessDialog.value = true

      // Reset feedback
      resetFeedback()

      // Start countdown
      startSuccessCountdown()

      // Play success sound
      playSound(successSound.value)
    }
  }).catch(error => {
    processing.value = false
    console.error('❌ Check-out error:', error)

    // Show error dialog
    // errorMessage.value = error.response?.data?.message || error.message || 'Failed to process check-out'
    errorMessage.value = 'Failed to process check-out'
    showErrorDialog.value = true

    // Play error sound
    playSound(errorSound.value)

    // Resume scanning by resetting processing
    setTimeout(() => {
      processing.value = false
    }, 3000)
  })
}

const submitFeedback = async () => {
  if (!feedback.value.rating) {
    toast.error('Please provide a rating')
    
    return
  }

  submittingFeedback.value = true

  // * Review API Call
  await $api('/care-visit/kiosk/visit-review', {
    method: 'POST',
    body: JSON.stringify({
      session_id: checkOutData.value.session_id,
      visit_rating: feedback.value.rating,
      visit_feedback: feedback.value.comment,
    }),
  }).then(response => {
      
    submittingFeedback.value = false

    // Reset feedback
    resetFeedback()

    // showFeedbackDialog.value = false

    // Show success dialog
    // showSuccessDialog.value = true

    closeSuccessDialog()

    // Start countdown
    // startSuccessCountdown()

    toast.success('Review submitted successfully!')
  }).catch(error => {
    submittingFeedback.value = false
    console.error('Visit Review submission error:', error)

    toast.error('Failed to submit feedback. Please try again.')
  })
}

const skipFeedback = async () => {
  showFeedbackDialog.value = false

  // Submit check-out without feedback
  try {
    // TODO: Replace with actual API endpoint for check-out without feedback
    // const response = await $api('/care-visit/check-out', {
    //   method: 'POST',
    //   body: JSON.stringify({
    //     visitor_id: checkOutData.value.visitor_id,
    //     qr_code: lastScannedCode,
    //     timestamp: new Date().toISOString(),
    //   }),
    // })

    // Simulated API call
    // await new Promise(resolve => setTimeout(resolve, 500))

    // Show success dialog
    // successData.value = checkOutData.value
    showSuccessDialog.value = true

    // Reset feedback
    resetFeedback()

    // Start countdown
    startSuccessCountdown()
  } catch (error) {
    console.error('Skip feedback error:', error)
    toast.error('Failed to complete check-out')

    // Resume scanning by setting processing to false
    setTimeout(() => {
      processing.value = false
    }, 1000)
  }
}

const resetFeedback = () => {
  feedback.value = {
    rating: 0,
    comment: '',
  }
}

// const startFeedbackDialogAutoSkipCountDown = () => {
//   feedbackDialogAutoSkipCountdown.value = 5

//   countdownInterval = setInterval(() => {
//     if (
//       feedback.value.rating == 0 && 
//       feedback.value.comment == ''
//     ) {
//       feedbackDialogAutoSkipCountdown.value--

//       if (feedbackDialogAutoSkipCountdown.value <= 0) {
//         clearInterval(countdownInterval)
//         skipFeedback()
//       }
//     } else {
//       clearInterval(countdownInterval)
//     }
//   }, 1000)
// }

// watch(() => showFeedbackDialog.value, value => {
//   if (value === true) {
//     startFeedbackDialogAutoSkipCountDown()
//   } 
// })

const startSuccessCountdown = () => {
  successCountdown.value = 5

  countdownInterval = setInterval(() => {
    // Check User Filling Feedback Or Not
    if (
      feedback.value.rating == 0 && 
      feedback.value.comment == ''
    ) {
      successCountdown.value--

      if (successCountdown.value <= 0) {
        clearInterval(countdownInterval)
        resetFeedback()
        closeSuccessDialog()
      }
    }
  }, 1000)
}

const closeSuccessDialog = () => {
  showSuccessDialog.value = false
  successData.value = null
  checkOutData.value = null

  if (countdownInterval) {
    clearInterval(countdownInterval)
  }

  // Resume scanning by setting processing to false
  setTimeout(() => {
    processing.value = false
  }, 500)
}

const closeErrorDialog = () => {
  showErrorDialog.value = false
  errorMessage.value = ''

  // Resume scanning by setting processing to false
  processing.value = false
}

const startErrorCountdown = () => {
  errorCountdown.value = 3

  countdownInterval = setInterval(() => {
    errorCountdown.value--

    if (errorCountdown.value <= 0) {
      clearInterval(countdownInterval)
      closeErrorDialog()
    }
  }, 1000)
}

watch(() => showErrorDialog.value, value => {
  if (value === true) {
    startErrorCountdown()
  }
})

const playSound = audioElement => {
  if (audioElement) {
    audioElement.currentTime = 0
    audioElement.play().catch(err => {
      console.log('Audio play failed:', err)
    })
  }
}

const onClickBack = () => {
  router.push({ name: 'care-visit-kiosk-panel' })
}

// * Call Heartbeat API In Every 5 Minutes
const heartbeat = () => {
  setInterval(async () => {
    await $api('/care-visit/kiosk/heartbeat', {
      method: 'POST',
    }).then(({}) => {
      isDeviceOnline.value = true
    }).catch(error => {
      isDeviceOnline.value = false
    })
  }, 300000)
}

// Lifecycle
onMounted(() => {
  // heartbeat()

  console.log('✅ Check-out page mounted')
  console.log('📦 QrcodeStream component imported:', QrcodeStream)
})

onUnmounted(() => {
  if (countdownInterval) {
    clearInterval(countdownInterval)
  }
  console.log('👋 Check-out page unmounted')
})
</script>

<style scoped>
.check-out-page {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: #000;
  block-size: 100vh;
}

.header-card {
  flex-shrink: 0;
  border-radius: 0 !important;
}

.camera-container {
  position: relative;
  display: flex;
  overflow: hidden;
  flex: 1;
  align-items: center;
  justify-content: center;
  background: #000;
}

.camera-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  block-size: 100%;
  color: white;
  inline-size: 100%;
  text-align: center;
}

.qr-scanner {
  position: relative;
  block-size: 100%;
  inline-size: 100%;
}

.scanning-overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  inset: 0;
  pointer-events: none;
}

.scan-frame {
  position: relative;
  border: 2px solid rgba(255, 255, 255, 50%);
  block-size: 300px;
  inline-size: 300px;
}

.corner {
  position: absolute;
  border: 3px solid #ff9800;
  block-size: 30px;
  inline-size: 30px;
}

.corner-tl {
  border-block-end: none;
  border-inline-end: none;
  inset-block-start: -2px;
  inset-inline-start: -2px;
}

.corner-tr {
  border-block-end: none;
  border-inline-start: none;
  inset-block-start: -2px;
  inset-inline-end: -2px;
}

.corner-bl {
  border-block-start: none;
  border-inline-end: none;
  inset-block-end: -2px;
  inset-inline-start: -2px;
}

.corner-br {
  border-block-start: none;
  border-inline-start: none;
  inset-block-end: -2px;
  inset-inline-end: -2px;
}

.scan-line {
  position: absolute;
  animation: scan 2s ease-in-out infinite;
  background: linear-gradient(90deg, transparent, #ff9800, transparent);
  block-size: 2px;
  inline-size: 100%;
}

@keyframes scan {
  0% {
    inset-block-start: 0;
  }

  50% {
    inset-block-start: 100%;
  }

  100% {
    inset-block-start: 0;
  }
}

.badges-left {
  position: absolute;
  z-index: 10;
  display: flex;
  gap: 0.5rem;
  inset-block-start: 1rem;
  inset-inline-start: 1rem;
}

.badges-right {
  position: absolute;
  z-index: 10;
  display: flex;
  gap: 0.5rem;
  inset-block-start: 1rem;
  inset-inline-end: 1rem;
}

.text-medium-emphasis {
  opacity: 0.68;
}

.gap-2 {
  gap: 0.5rem;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .scan-frame {
    block-size: 250px;
    inline-size: 250px;
  }

  .camera-container {
    min-block-size: 50vh;
  }

  .video-wrapper {
    block-size: 50vh;
  }
}

.custom-rating :deep(.v-icon) {
  font-size: 40px !important; /* Adjust size as needed */
}
</style>
